import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Login',
      description: 'Multi-factor authentication available'
    },
    {
      icon: 'Eye',
      title: 'Privacy Protected',
      description: 'We never share your personal information'
    }
  ];

  const certifications = [
    {
      name: 'SOC 2 Compliant',
      icon: 'Award',
      color: 'text-success'
    },
    {
      name: 'GDPR Compliant',
      icon: 'CheckCircle',
      color: 'text-primary'
    },
    {
      name: 'ISO 27001',
      icon: 'Shield',
      color: 'text-warning'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="bg-surface rounded-lg p-6 border border-border">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Shield" size={20} className="mr-2 text-success" />
          Your Security is Our Priority
        </h3>
        <div className="space-y-4">
          {securityFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={16} color="var(--color-success)" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-text-primary">{feature?.title}</h4>
                <p className="text-xs text-text-secondary mt-1">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Certifications */}
      <div className="bg-surface rounded-lg p-6 border border-border">
        <h3 className="text-base font-semibold text-text-primary mb-4">
          Trusted & Certified
        </h3>
        <div className="grid grid-cols-1 gap-3">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-center space-x-3 p-2 rounded-lg hover:bg-muted transition-colors duration-200">
              <Icon name={cert?.icon} size={16} className={cert?.color} />
              <span className="text-sm font-medium text-text-primary">{cert?.name}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Help & Support */}
      <div className="bg-primary/5 rounded-lg p-6 border border-primary/20">
        <h3 className="text-base font-semibold text-text-primary mb-3 flex items-center">
          <Icon name="HelpCircle" size={18} className="mr-2 text-primary" />
          Need Help?
        </h3>
        <p className="text-sm text-text-secondary mb-4">
          Our support team is available 24/7 to assist you with any login issues.
        </p>
        <div className="flex flex-col sm:flex-row gap-2">
          <a
            href="mailto:support@clean360.com"
            className="flex items-center space-x-2 text-sm text-primary hover:underline"
          >
            <Icon name="Mail" size={14} />
            <span>support@clean360.com</span>
          </a>
          <a
            href="tel:+1234567890"
            className="flex items-center space-x-2 text-sm text-primary hover:underline"
          >
            <Icon name="Phone" size={14} />
            <span>(123) 456-7890</span>
          </a>
        </div>
      </div>
      {/* Privacy Links */}
      <div className="text-center space-y-2">
        <div className="flex justify-center space-x-4 text-xs text-text-secondary">
          <a href="#" className="hover:text-text-primary transition-colors duration-200">
            Privacy Policy
          </a>
          <span>•</span>
          <a href="#" className="hover:text-text-primary transition-colors duration-200">
            Terms of Service
          </a>
          <span>•</span>
          <a href="#" className="hover:text-text-primary transition-colors duration-200">
            Cookie Policy
          </a>
        </div>
        <p className="text-xs text-text-secondary">
          © {new Date()?.getFullYear()} Clean360. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default TrustIndicators;